import { useDraggable, type UseDraggableArguments } from "@dnd-kit/core";

export const Draggable: React.FC<
  React.PropsWithChildren<UseDraggableArguments>
> = ({ children, ...props }) => {
  const { isDragging, attributes, listeners, setNodeRef } = useDraggable(props);
  return (
    <div
      ref={setNodeRef}
      className="grid touch-manipulation overflow-hidden rounded border hover:cursor-grab"
      style={{ opacity: isDragging ? 0.5 : 1 }}
      {...listeners}
      {...attributes}
    >
      {children}
    </div>
  );
};
